<template>
    <div>
        <b-modal
			id="modalTransactions"
            ref="modalSelectTransaction"
            hide-footer
            size="sm"
            no-overflow
            hide-no-focus="true"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">Tipo de transação</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModalTransaction()"
                >
                    <xIcon/>
                </div>
            </div>
			<div class="container-options-menu-float">
				<button v-if="possuiPermissao('GER_I_TRANSFER') || possuiPermissao('GER_U_TRANSFER')" class="btn-menu-transactions" @click="optionTransactionTypeMenu(1)"><RefreshCwIcon color="#08f53f" class="icon-menu-float"/>{{ optionsTransactionType[0].text }}</button>
				<button v-if="possuiPermissao('GER_I_RENDAS') || possuiPermissao('GER_U_RENDAS')" class="btn-menu-transactions" @click="optionTransactionTypeMenu(2)"><ArrowDownRightIcon color="#08f53f" class="icon-menu-float"/>{{ optionsTransactionType[1].text }}</button>
				<button v-if="possuiPermissao('GER_I_DESPESAS') || possuiPermissao('GER_U_DESPESAS')" class="btn-menu-transactions" @click="optionTransactionTypeMenu(3)"><ArrowUpLeftIcon color="#fa0202" class="icon-menu-float"/>{{ optionsTransactionType[2].text }}</button>
				<button v-if="possuiPermissao('GER_I_RECEIVE') || possuiPermissao('GER_U_RECEIVE')" class="btn-menu-transactions" @click="optionTransactionTypeMenu(5)"><CalendarIcon color="#08f53f" class="icon-menu-float"/>{{ optionsTransactionType[4].text }}</button>
				<button v-if="possuiPermissao('GER_I_AGENDAMENTOS') || possuiPermissao('GER_U_AGENDAMENTOS')" class="btn-menu-transactions" @click="optionTransactionTypeMenu(4)"><CalendarIcon color="red" class="icon-menu-float"/>{{ optionsTransactionType[3].text }}</button>
			</div>

        </b-modal>
        <b-modal
            ref="modalFormTransaction"
            hide-footer
            size="md"
            no-overflow
            hide-no-focus="true"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">{{ titleModalTransaction }}</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModalTransaction()"
                >
                    <xIcon/>
                </div>
            </div>
			<section>
				<div
					v-if="saving"
					style="position: fixed; top: calc(50vh - 4rem); left: calc(50vw - 1rem); display: flex; align-items: center; justify-content: center; z-index: 1;"
				>
					<div class="spinner-border" role="status"/>
				</div>
			</section>
			<div class="modal-edicao modal-edicao-label mt-6">
				<section v-if="transactionType === 1">
					<FormTransfer
						:transactionDocument="transactionDocument"
						:toSave="saving"
						:clearFields="clearFields"
						@invalidForm="validateForm"
						@saved="handleSave"
						@clearedFields="clearedFields"
					/>
				</section>
				<section v-else-if="transactionType === 2">
					<FormIncome
						:transactionDocument="transactionDocument"
						:toSave="saving"
						:clearFields="clearFields"
						@invalidForm="validateForm"
						@saved="handleSave"
						@clearedFields="clearedFields"
					/>
				</section>
				<section v-else-if="transactionType === 3">
					<FormExpense
						:transactionDocument="transactionDocument"
						:toSave="saving"
						:clearFields="clearFields"
						@invalidForm="validateForm"
						@saved="handleSave"
						@clearedFields="clearedFields"
					/>
				</section>
				<section v-else-if="transactionType === 4">
					<FormTopay
						:transactionDocument="transactionDocument"
						:toSave="saving"
						:clearFields="clearFields"
						@invalidForm="validateForm"
						@saved="handleSave"
						@clearedFields="clearedFields"
					/>
				</section>
				<section v-else-if="transactionType === 5">
					<FormToReceive
						:transactionDocument="transactionDocument"
						:toSave="saving"
						:clearFields="clearFields"
						@invalidForm="validateForm"
						@saved="handleSave"
						@clearedFields="clearedFields"
					/>
				</section>
			</div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModalTransaction()">Cancelar</b-button>
            <b-button v-if="!editing" class="mt-3 float-left btn-modal btn-limpar" @click="clearModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="save"
                :disabled="invalidForm || saving"
            >
                Salvar
            </b-button>

        </b-modal>
    </div>
</template>

<script>
	import { possuiPermissao } from "../../helpers/permissions";
	import FormIncome from "@/components/Transactions/FormIncome.vue";
	import FormTransfer from "@/components/Transactions/FormTransfer.vue";
	import FormExpense from "@/components/Transactions/FormExpense.vue";
	import FormTopay from "@/components/Transactions/FormTopay.vue";
	import FormToReceive from "@/components/Transactions/FormToReceive.vue";
	import emitter from "@/eventBus.js";

	export default {
		name: "Transactions",
		components: {
			FormIncome,
			FormTransfer,
			FormExpense,
			FormTopay,
			FormToReceive
		},

		props: {
			typeTransactionDefault: {
				type: Number,
				required: false,
				default: null
			},
			transactionDocument: {
				type: Object,
				required: true
			}
		},
		data () {
			return {
				possuiPermissao,
				optionsTransactionType: [{
					value: 1,
					text: "Transferência",
					enum: "TRANSFER"
				}, {
					value: 2,
					text: "Entrada",
					enum: "INCOME"
				}, {
					value: 3,
					text: "Saída",
					enum: "EXPENSES"
				}, {
					value: 4,
					text: "Conta a pagar",
					enum: "TOPAY"
				}, {
					value: 5,
					text: "Conta a receber",
					enum: "TORECEIVE"
				}],

				transactionType: null,
				loading: false,
				titleModalTransaction: "",
				editing: false,
				saving: false,
				invalidForm: true,
				clearFields: false

			};
		},

		async mounted () {
			this.editing = Boolean(this.transactionDocument.idOperation);

			if (this.editing || this.typeTransactionDefault)
				return this.optionTransactionTypeSelected();

			this.$refs.modalSelectTransaction.show();
		},

		methods: {
			optionTransactionTypeSelected () {
				if (this.typeTransactionDefault)
					this.transactionType = this.typeTransactionDefault;

				if (this.editing) {
					const type = this.transactionDocument.transactionType;
					const optionSelected = this.optionsTransactionType.filter(ott => ott.enum === type);
					this.transactionType = optionSelected[0]?.value || null;

					this.titleModalTransaction = "Alterando ";
					this.titleModalTransaction = this.titleModalTransaction.concat(optionSelected[0]?.text || "");

				} else {
					this.titleModalTransaction = "Nova ";
					const optionSelected = this.optionsTransactionType.filter(ott => ott.value === this.transactionType);
					this.titleModalTransaction = this.titleModalTransaction.concat(optionSelected[0]?.text || "");
				}

				this.$refs.modalFormTransaction.show();
			},

			optionTransactionTypeMenu (transactionType) {
				if (this.typeTransactionDefault)
					this.transactionType = this.typeTransactionDefault;

				if (this.editing) {
					const type = this.transactionDocument.transactionType;
					const optionSelected = this.optionsTransactionType.filter(ott => ott.enum === type);
					this.transactionType = optionSelected[0]?.value || null;

					this.titleModalTransaction = "Alterando ";
					this.titleModalTransaction = this.titleModalTransaction.concat(optionSelected[0]?.text || "");

				} else {
					this.transactionType = transactionType;
					this.titleModalTransaction = "Nova ";
					const optionSelected = this.optionsTransactionType.filter(ott => ott.value === this.transactionType);
					this.titleModalTransaction = this.titleModalTransaction.concat(optionSelected[0]?.text || "");
				}

				this.$refs.modalFormTransaction.show();
			},

			closeModalTransaction () {
				this.$emit("closeModalTransaction", true);
			},

			validateForm (errorForm) {
				this.invalidForm = errorForm;
			},

			save () {
				this.saving = true;
			},

			async handleSave (saved) {
				if (saved) {
					this.clearModal();
					this.$emit("searchTransaction", true);
					this.$emit("saved", true);

					emitter.emit("reloadAccount", { reload: true });
					if ( this.$route.path === "/") {
						emitter.emit("reloadTransactions", { reload: true });
					}

					let addNewRecord = false;
					if (!this.editing) {
						await this.await(2000);
						this.saving = false;
						addNewRecord = (await this.$swal({
							title: "Transação realizada com sucesso",
							text: "Deseja adicionar outra transação?",
							type: "success",
							showCancelButton: true,
							cancelButtonColor: "#A6A8AB",
							confirmButtonColor: "#DD6B55",
							imageWidth: 50,
							imageHeight: 50,
							cancelButtonText: "Não",
							confirmButtonText: "Sim",
							reverseButtons: true
						})).value;
					}

					if (!addNewRecord) {
						this.closeModalTransaction();
					}

				}
				this.saving = false;
			},

			clearModal () {
				this.clearFields = true;
			},

			clearedFields () {
				this.clearFields = false;
			},

			async await (ms) {
				return new Promise(resolve => setTimeout(resolve, ms));
			}
		}
	};

</script>


<style scoped>
:deep(#modalTransactions .modal-content) {
	background-color: var(--gris40) !important;
	max-width: 300px !important;
	margin-left: auto;
	margin-right: auto;
	margin-top: 5rem;
}

</style>